export type CookieOptions = {
  path?: string; // default: '/'
  domain?: string; // default: current domain
  expiresInMinutes?: number; // converted to milliseconds then a UTC string
  sameSite?: "Strict" | "Lax" | "None";
};

const getDefaultDomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  let domain = "";
  if (hostname !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    // For domains with enough parts, take the last two parts as the root domain
    const apexDomain = parts.length > 2 ? parts.slice(-2).join(".") : hostname;
    domain = `.${apexDomain}`;
  }
  return domain;
};

const getDomainPart = (domain: string) => {
  if (domain) {
    return `domain=${domain}`;
  }
  return "";
};

const getExpiresPart = (expiresInMinutes: number | undefined) => {
  if (expiresInMinutes) {
    const date = new Date();
    date.setTime(Date.now() + expiresInMinutes * 60 * 1000);
    return `expires=${date.toUTCString()}`;
  }
  return "";
};

export const setCookie = (
  name: string,
  value: string,
  options: CookieOptions = {},
) => {
  const defaultOptions: CookieOptions = {
    path: "/",
    sameSite: "Lax",
  };

  const mergedOptions = { ...defaultOptions, ...options };
  const { path, expiresInMinutes, sameSite } = mergedOptions;

  const expiresPart = getExpiresPart(expiresInMinutes);

  const domainPart = getDomainPart(options.domain || getDefaultDomain());

  const joinedParts = [
    `; path=${path}`,
    domainPart,
    expiresPart,
    `SameSite=${sameSite}`,
  ].filter(Boolean);
  const joinedPartsString = joinedParts.join("; ");
  document.cookie = `${name}=${encodeURIComponent(value)}${joinedPartsString}; secure`;
};
